module.exports = __webpack_public_path__ + "img/icon_level.54dafb6d.png";